export const bond = {
  internal: 'Interno',
  external: 'Externo',
};
